export enum LayerVisibility {
  visible = "visible",
  none = "none",
}
